export const FIELDS = [
  {
    name: 'rut',
    inputAdornment: '',
    label: 'RUT',
    disabled: false,
    required: true,
    helper: 'Sin puntos, pero con guión Ej: 12345678-9',
  },
  {
    name: 'name',
    inputAdornment: '',
    label: 'Nombre completo',
    disabled: false,
    required: true,
  },
  {
    name: 'phone',
    inputAdornment: '',
    label: 'Teléfono',
    textArea: '',
    disabled: false,
    required: true,
    helper: 'Ingresar 9 dígitos',
  },
  {
    name: 'email',
    inputAdornment: '',
    label: 'Correo',
    disabled: false,
    required: true,
  },
  {
    name: 'motive',
    inputAdornment: '',
    label: 'Motivo',
    disabled: false,
    required: true,
    inputType: 'select',
  },
  {
    name: 'invoiceNumber',
    inputAdornment: '',
    label: 'Número de Boleta/Factura',
    disabled: false,
    required: true,
  },
  {
    name: 'comment',
    inputAdornment: '',
    label: 'Escribir comentario',
    disabled: false,
    required: false,
    rows: 4,
    multiline: true,
  },
];
